import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { useCallback, type FC } from "react";
import { HeadsUpSidebarContent } from "./heads-up-sidebar-content";
import { useHeadsUpSidebar } from "./hooks";
import { HeadsUpContextProvider } from "@/components/heads-up/context/heads-up-context";
import {
  SIDE_PANEL_COLLAPSED_HEIGHT_PX,
  SIDE_PANEL_COLLAPSED_BUFFER_PX,
} from "@/app/router/constants";

export const HeadsUpSidebar: FC = observer(function HeadsUpSidebar() {
  const model = useHeadsUpSidebar();
  const { context, ui } = model;
  const { setHovered } = ui;

  const handleMouseEnter = useCallback(() => {
    setHovered(true);
  }, [setHovered]);

  const handleMouseLeave = useCallback(() => {
    setHovered(false);
  }, [setHovered]);

  if (!context.isDatabaseReady) {
    return (
      <Container
        data-heads-up-sidebar
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      />
    );
  }

  return (
    <Container
      data-heads-up-sidebar
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <HeadsUpContextProvider model={model}>
        <HeadsUpSidebarContent />
      </HeadsUpContextProvider>
    </Container>
  );
});

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% - ${SIDE_PANEL_COLLAPSED_HEIGHT_PX}px + ${SIDE_PANEL_COLLAPSED_BUFFER_PX}px);
  overflow: auto;
`;
